import { UserItemDtoPaginatedList } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import React from "react";
import { useTranslation } from "react-i18next";
import { ListUsersDrawer } from "views/foundation/user/drawers/ListUsersDrawer";

////////////////////////////////////////////////////////////////////////////////

interface IPros {
    publicationId: string;
    title: string;
    onClose: () => void;
}

export const WhoLikesDrawer: React.FC<IPros> = (props) => {

    const { publicationId, title, onClose } = props;

    const api = useCoreApi();
    const { t } = useTranslation("knowledge");

    return (
        <ListUsersDrawer
            title={t("Feed.Card.Actions.WhoLikesDrawer.Title")}
            subtitle={title}
            onGetData={({ searchText, pageNumber, pageSize }) =>
                new Promise<UserItemDtoPaginatedList>((resolve, reject) => {
                    api.v1.knowledgePublication.getWhoLikes({
                        publicationId: publicationId,
                        searchText: searchText,
                        pageNumber: pageNumber,
                        pageSize: pageSize
                    })
                        .then(result => resolve(result.data))
                        .catch(e => reject(e));
                })}
            onClose={onClose}
        />
    );
};
